import { render, staticRenderFns } from "./PartnerFinderExtra.vue?vue&type=template&id=15b7f85e&scoped=true&"
import script from "./PartnerFinderExtra.vue?vue&type=script&lang=js&"
export * from "./PartnerFinderExtra.vue?vue&type=script&lang=js&"
import style0 from "./PartnerFinderExtra.vue?vue&type=style&index=0&id=15b7f85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b7f85e",
  null
  
)

export default component.exports